import { ProjectTypes } from "../types/ProjectType";
import { DropdownItems } from "../types/DropdownItems";

export const convertProjectTypesToDropdownItems = (projectTypes: ProjectTypes): DropdownItems => {
    const dropdownItems: DropdownItems = {};
    for (const id in projectTypes) dropdownItems[parseInt(id)] = projectTypes[parseInt(id)].name
    return dropdownItems
}
